import React from 'react'
import heroImage from "../../images/dab83994ae88efb03924f9df75331b9a 1.webp"
import { Link } from 'react-router-dom';

function Section1() {
  return (
    <div className="relative w-full max-w-[1440px] mx-auto h-full md:px-[120px] pt-[100px] md:pt-[100-px] pb-24 flex flex-col md:flex-row gap-12">

      {/* Left Content (Text) - Slide in from left */}
      <div className="flex flex-col gap-12 max-w-[636px] z-0 animate-slide-in-left">
        <div className="flex flex-col gap-6">
          <h1 className="hero-text text-[#006633] font-bold text-[40px] md:text-[56px] leading-[1.2] md:leading-[67px]">
            Advancing Carbon Management for Real-World Impact
          </h1>
          <p className="hero-text text-[#3B3B3B] font-medium text-[28px] md:text-[28px] leading-[1.4] md:leading-[33px] mb-5">
            We redefine carbon management through real-time monitoring and verified impact empowering individuals and organizations to take credible climate action.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-6">
          <a
            href="#plans"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('plans')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="hero-btn group flex justify-center items-center border-2 border-[#E4E7EC] py-[12px] gap-[10px] w-full sm:w-[306px] h-[56px] bg-[#0D924F] rounded-xl hover:bg-[#0d713f] transition-all cursor-pointer"
          >
            <span className="font-medium text-[24px] text-white text-center">
              Get Started
            </span>
          </a>
          <Link to="/donate" className="hero-btn font-medium text-[24px] text-[#006633]/90 hover:text-white group box-border flex justify-center items-center px-[18px] py-[12px] gap-[10px] w-full sm:w-[306px] h-[56px] bg-white/80 border rounded-xl hover:bg-[#006633] hover:text-white transition-all cursor-pointer">
        
              Voluntary Donation

          </Link>
        </div>
      </div>

      {/* Right Content (Image) - Slide in from right */}
      <img
        fetchPriority="high"
        className="object-contain hero-image-container hidden md:block absolute right-0 top-[20%] xl:top-[calc(50%-250px)] xl:left-[792px] w-[500px] xl:w-[556px] h-[503px] z-0 pointer-events-none animate-slide-in-right"
        src={heroImage}
        alt="Carbon Management"
      />
    </div>
  )
}

export default Section1